// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YYjdR","image":"Header_image__-xMo6","name":"Header_name__2bk7H","info":"Header_info__1AaCO","infoRow":"Header_infoRow__3uqJ6"};